import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 

import CloseIcon from '@mui/icons-material/Close';



import ReactHTMLTableToExcel from 'react-html-table-to-excel';




import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
export default class PaymentRefBox extends Component {

   constructor(props) {
super(props)
	 
	 
     this.state = { 
	 ledgerlabel:'Please select',PaymnetData:[],
        open:false,
		payrefopen:false,  
		isDisabled: false ,ledger:'',
		printremittance:false,
      pmt_reference:'',ledgerdata:[],errormessage:'',erropen:false,errortype:"error",pmt_paymenttype:'',
  }
  
 
 
   }


handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }

handleClickOpen = (e) => {

  this.setState({payrefopen:!this.state.payrefopen,  
	  },()=>{
		  
		
  axios.get(localStorage.getItem("ISIurl") + 'ajaxpayments.php?action=getall&pmt_type='+this.props.pmt_type+'&pref_mainid='+this.props.pref_mainid)
    .then(resp => {
      if (resp.data.length > 0) {
      

        this.setState({
          PaymnetData: resp.data,
          paycount: parseInt(resp.data[0].count),
		 
        }, () => {
        
        });
      } else {
        this.setState({ PaymnetData: [] });
      }
	 
    });
	
	
	

		  
		  
		  
	  });
	  
	  
};






   myChangeHandler = (event) => {
  
  let nam = event.target.name;
  let val = event.target.value;	  
 
	   this.setState({[nam]: val});	    
   
}
Oncloseicon =()=>{
	
  this.setState({payrefopen:!this.state.payrefopen,  
	  });
	
}


 render(){
	 let discount=0; 
	 let grandTotal=0;
  return (

   <React.Fragment>

   <div className="checkbox">
<Dialog
  open={this.state.payrefopen}
  onClose={this.handleClose}
  maxWidth={false}
  PaperProps={{
    style: {
      width: '1000px',  
      maxWidth: 'none' ,
	  backgroundColor:'#f2f5f6',
	  borderRadius: '15px'
    }
  }}
>
  <DialogTitle id="form-dialog-title" className="dialoghead">
    <h4><b>Payments and Allocations</b></h4>
	<p>A detailed breakdown of payments and allocations.</p>
	<span onClick={this.Oncloseicon} className="closeicon">
	<CloseIcon/>
	</span>

  </DialogTitle>
  
  

  
    <div className="refunddialogue">
  <DialogContent>
  
      

    <Paper>
            <TableContainer className="table-container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="table-head" style={{"width":"40%"}} >Date</TableCell>
                    <TableCell className="table-head" style={{"width":"40%"}} >Type</TableCell>
                    <TableCell className="table-head" style={{"width":"5%"}}>Reference</TableCell>
                    <TableCell className="table-head " style={{"width":"10%"}}>Amount</TableCell>
                    <TableCell className="table-head " style={{"width":"20%"}}>Discount</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {this.state.PaymnetData.map((item, index) => {
                 grandTotal += Number(item.pref_amount);
				 discount+= Number(item.pref_discount);
                    return (
                      <React.Fragment key={index}>
					  
					   
					  
                        <TableRow className="table-cell" style={{ backgroundColor: '#f1f5f6' }}>
                          <TableCell className="table-cell">
                           
                            {item.paylastdate}
                          </TableCell>
                          <TableCell className="table-cell">{item.paytype}</TableCell>
                          <TableCell className="table-cell">{item.pmt_reference}</TableCell>
						  <TableCell className="table-cell">{item.pref_amount} </TableCell>
                          
                          <TableCell className="table-cell"><p>{item.pref_discount}</p> </TableCell>
                         
                        </TableRow>
						
                      </React.Fragment>
                    );
                  })}

						  <TableRow>
						 <TableCell colSpan="3"><p>Total Paid/Allocated</p></TableCell>
						  <TableCell >${grandTotal}</TableCell>
						   <TableCell >{discount}</TableCell>
						  </TableRow>


                         <TableRow>
						 <TableCell colSpan="3"></TableCell>
						  <TableCell ><b>Total</b></TableCell>
						 <TableCell ><b>${this.props.Grndtotal}</b></TableCell>
						  </TableRow>
						  
						  
						  <TableRow>
						 <TableCell colSpan="3"></TableCell>
						  <TableCell ><b>Paid/Allocated</b></TableCell>
						 <TableCell ><b>${grandTotal}</b></TableCell>
						  </TableRow>
			 
			   
						  <TableRow>
						 <TableCell colSpan="3"></TableCell>
						  <TableCell ><b>Outstanding</b></TableCell>
						 <TableCell ><b>{this.props.outstandingamt}</b></TableCell>
						  </TableRow>
			          
			 

			
				  
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
      
	 
	  
	  
  
  </DialogContent>  </div>
</Dialog>
  </div>
  
  </React.Fragment>
 )
 
 
 }
 
 
  }